import { BaseFirestoreData, PathParam } from "../util/base-firestore";
import { type ContactData } from "../model/contact";
import { DateTime } from "luxon";

export class Client extends BaseFirestoreData {
  organizationId: string;
  clientId: string;

  name: string; // 顧客名
  title: string; // 敬称 // 様

  contacts: ContactData[];
}

export const getEmptyClient = (): Client => {
  return {
    organizationId: "",
    clientId: "",

    name: "",
    title: "",
    contacts: [],

    createdAt: DateTime.now(),
    updatedAt: DateTime.now(),
    deletedAt: null,
  };
};

export class ClientCollectionPathParam extends PathParam {
  organizationId: string;
}
export class ClientDocumentPathParam extends PathParam {
  organizationId: string;
  clientId: string;
}

export const ClientPath = [
  {
    path: "organizations/{organizationId}/clients",
    primaryKey: "clientId",
    param: ClientCollectionPathParam,
    class: Client,
    isCollection: true,
  },
  {
    path: "organizations/{organizationId}/clients/{clientId}",
    primaryKey: "clientId",
    param: ClientDocumentPathParam,
    class: Client,
  },
] as const;
